import api from './api';

export const offerAPI = {
  // Create a new custom offer
  createOffer: async (offerData) => {
    try {
      // Rename buyerId to buyer for backend compatibility
      const backendData = {
        ...offerData,
        buyer: offerData.buyerId
      };
      delete backendData.buyerId;

      console.log('📦 Creating offer:', backendData);
      const response = await api.post('/offers/create', backendData);
      console.log('✅ Offer created successfully:', response.data);
      return response;
    } catch (error) {
      console.error('❌ Error creating offer:', error);
      throw new Error(error.response?.data?.error || 'Failed to create offer');
    }
  },

  // Get offers for a conversation
  getOffersByConversation: async (conversationId) => {
    try {
      const response = await api.get(`/offers/conversation/${conversationId}`);
      return response;
    } catch (error) {
      console.error('❌ Error fetching offers:', error);
      throw error;
    }
  },

  // Accept an offer
  acceptOffer: async (offerId, data = {}) => {
    try {
      const response = await api.patch(`/offers/${offerId}/accept`, data);
      return response;
    } catch (error) {
      console.error('❌ Error accepting offer:', error);
      throw error;
    }
  },

  // Reject an offer
  rejectOffer: async (offerId, data = {}) => {
    try {
      const response = await api.patch(`/offers/${offerId}/reject`, data);
      return response;
    } catch (error) {
      console.error('❌ Error rejecting offer:', error);
      throw error;
    }
  },

  // Get offer by ID
  getOfferById: async (offerId) => {
    try {
      const response = await api.get(`/offers/${offerId}`);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching offer:', error);
      throw error;
    }
  },

  // Update offer
  updateOffer: async (offerId, updateData) => {
    try {
      const response = await api.patch(`/offers/${offerId}`, updateData);
      return response.data;
    } catch (error) {
      console.error('❌ Error updating offer:', error);
      throw error;
    }
  },

  // Delete offer
  deleteOffer: async (offerId) => {
    try {
      const response = await api.delete(`/offers/${offerId}`);
      return response.data;
    } catch (error) {
      console.error('❌ Error deleting offer:', error);
      throw error;
    }
  },

  // Get all offers for current user
  getUserOffers: async () => {
    try {
      const response = await api.get('/offers/user');
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching user offers:', error);
      throw error;
    }
  },

  // Update offer status
  updateOfferStatus: async (offerId, status) => {
    try {
      const response = await api.patch(`/offers/${offerId}/status`, { status });
      return response.data;
    } catch (error) {
      console.error('❌ Error updating offer status:', error);
      throw error;
    }
  }
};

// Payment API functions
export const paymentAPI = {
  // Create Stripe checkout session
  createCheckoutSession: async (paymentData) => {
    try {
      console.log('💳 Creating checkout session:', paymentData);
      const response = await api.post('/payments/create-checkout-session', paymentData);
      console.log('✅ Checkout session created:', response.data);
      return response;
    } catch (error) {
      console.error('❌ Error creating checkout session:', error);
      throw error;
    }
  },

  // Verify payment
  verifyPayment: async (sessionId) => {
    try {
      const response = await api.get(`/payments/verify/${sessionId}`);
      return response.data;
    } catch (error) {
      console.error('❌ Error verifying payment:', error);
      throw error;
    }
  },

  // Get payment status from Stripe
  getPaymentStatus: async (sessionId) => {
    try {
      const response = await api.get(`/payments/status/${sessionId}`);
      return response.data;
    } catch (error) {
      console.error('❌ Error getting payment status:', error);
      throw error;
    }
  }
};

export default offerAPI;
